// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style__tabs__4-JsR","vertical":"style__vertical__FhtKr","tabsLeft":"style__tabsLeft__xrGqs"};